import { forwardRef, useState } from 'react';
import * as Styles from './styles';
import { InputProps } from 'antd';

interface Props extends InputProps {
  symbol?: string
  onChange?: (e: any) => void
}

export const CurrencyInput = forwardRef<any, any>((props: Props, ref: any) => {

  const inputProps = { ...props } as InputProps

  const [amount, setAmount] = useState<string>('');

  const handleInputChange = (event) => {
    if (props.onChange) {
      props.onChange(event)
    } else {
      const inputValue = event.target.value;
      const sanitizedInput = inputValue.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
      setAmount(sanitizedInput);
    }
  };

  const handleFocus = (event: React.FocusEvent<HTMLInputElement>) => {
    event.target.select();
  };

  return (
    <Styles.CurrencyInput
      ref={ref}
      prefix={props.symbol ?? 'Q'}
      onChange={handleInputChange}
      value={!props.onChange ? amount : undefined}
      {...inputProps}
      onFocus={handleFocus}
    />
  )
})